import React, { useMemo, useState } from "react";
import NoData from "../Info/NoData";
import FormFieldSet from "../FormFields/FormFieldSet";
import { buildTreeModel } from "./supportFiles/buildTreeModel";
import { layoutLeftToRight } from "./supportFiles/layoutLeftToRight";
import TreeHierarchyChart from "./supportFiles/TreeHierarchyChart";
import RootJobsModal from "./supportFiles/RootJobsModal";
import BdmJobsModal from "./supportFiles/BdmJobsModal";
import InternalSubmissionModal from "./supportFiles/InternalSubmissionModal";
import StageModal from "./supportFiles/StageModal";
import Button from "../Buttons/Button";
import Modal from "../Modal/Modal";
import ExtraCountsModal from "./SupportFiles/ExtraCountsModal";

const TreeHierarchy = ({
  countsData = [],
  data = [],
  duration = {
    from: new Date(),
    to: new Date(),
  },
  onDurationChange = () => { },
  onNodeClick = () => { },
  page,
  limit,
  setPage,
  handleLimitChange,
  onStageNumberChange,
  tab2Data,
  tab3Data,
  tab2TotalCount,
  tab3TotalCount,
  loading,
  viewMode = "scroll",
  onSubmissionClick,
  submissionClickData,
  subPage,
  subLimit,
  subSetPage,
  subHandleLimitChange,
  showFullScreen = true,
  type,
  extraCounts,
  extraCountsData,
  nodeParams
}) => {

  const hasData = true
  // const model = useMemo(() => buildTreeModel(data), [data]);
  const layout = useMemo(() => layoutLeftToRight(countsData, type, extraCounts), [countsData, type, extraCounts]);
  const [isRootModalOpen, setIsRootModalOpen] = useState(false);
  const [isBdmModalOpen, setIsBdmModalOpen] = useState(false);
  const [isInternalModalOpen, setIsInternalModalOpen] = useState(false);
  const [isStageModalOpen, setIsStageModalOpen] = useState(false);
  const [activeEmployeeId, setActiveEmployeeId] = useState(null);
  const [activeEmployeeIdForStage, setActiveEmployeeIdForStage] =
    useState(null);
  const [activeStageName, setActiveStageName] = useState(null);
  const [selectedNodeId, setSelectedNodeId] = useState(null);
  const [isFullscreenOpen, setIsFullscreenOpen] = useState(false);
  const [extraCountsModal, setExtraCountsModal] = useState(false)

  const handleNodeClick = (payload) => {
    console.log(payload)
    if (payload?.type === "root") setIsRootModalOpen(true);
    if (payload?.type === "employee") {
      setActiveEmployeeId(payload?.employeeId ?? null);
      setIsBdmModalOpen(true);
    }
    if (payload?.type === "employeeMetric") {
      setActiveEmployeeId(payload?.employeeId ?? null);
      setExtraCountsModal(true);
    }
    if (payload?.type === "stage") {
      const stageName = payload?.stageName ?? null;
      const allowed =
        stageName === "Internal Submission" ||
        stageName === "Client Submissions" ||
        stageName === "Aggrements" ||
        stageName === "Interview Round 1" ||
        stageName === "Interview Round 2" ||
        stageName === "Interview Round 3" ||
        stageName === "Placements";

      if (allowed) {
        setActiveEmployeeIdForStage(payload?.employeeId ?? null);
        setActiveStageName(stageName);
        if (stageName === "Internal Submission") setIsInternalModalOpen(true);
        else setIsStageModalOpen(true);
      }
    }
    if (typeof onNodeClick === "function") onNodeClick(payload);
  };

  const treeContent = (
    <div className="w-full h-full flex flex-1 flex-col overflow-hidden gap-2">
      <div className="HeaderTool flex items-center justify-end mt-5 relative">
        <div className="flex items-center gap-2">
          <div className="min-w-[300px]">
            <FormFieldSet
              title="Select Date"
              noTitle
              type="datepickerRange"
              value={duration}
              onChange={onDurationChange}
              maxDate={new Date()}
            />
          </div>
          {showFullScreen && (
            <Button
              type="icon"
              variant="text"
              color="black"
              icon={!isFullscreenOpen ? "fullscreen" : "fullscreen_exit"}
              title={!isFullscreenOpen ? "Fullscreen" : "Exit Fullscreen"}
              onClick={() => setIsFullscreenOpen(!isFullscreenOpen)}
            />
          )}
        </div>
      </div>
      {!hasData ? (
        <div className="flex items-center justify-center flex-1">
          <NoData title="No data for selected range" />
        </div>
      ) : (
        <div className="w-full flex-1 overflow-hidden">
          <TreeHierarchyChart
            layout={layout}
            onNodeClick={handleNodeClick}
            selectedNodeId={selectedNodeId}
            onNodeSelect={setSelectedNodeId}
            viewMode={viewMode}
            className={isFullscreenOpen ? "" : "max-h-[60vh]"}
          />
        </div>
      )}
    </div>
  );

  return (
    <div className="flex-1 w-full flex flex-col gap-1 overflow-hidden">
      {!isFullscreenOpen && treeContent}

      <Modal
        showCloseButton={false}
        isOpen={isFullscreenOpen}
        onClose={() => setIsFullscreenOpen(false)}
        width="max-w-[100vw]"
        wrapperClassName="p-0!"
        panelClassName="!max-h-[100dvh] h-[100dvh] rounded-none!"
        bodyClassName="p-0! flex flex-1 overflow-hidden"
        closeOnOutsideClick
        zIndex={48}
      >
        <div className="w-full overflow-hidden flex flex-col flex-1">
          {treeContent}
        </div>
      </Modal>
      <RootJobsModal
        isOpen={isRootModalOpen}
        onClose={() => {

          setIsRootModalOpen(false);
          setSelectedNodeId(null);
          setPage(1)
          handleLimitChange(25)
        }}
        data={data}
        totalCount={countsData?.[0]?.totalJobsCount ?? 0}
        page={page}
        limit={limit}
        setPage={setPage}
        handleLimitChange={handleLimitChange}
        type={type}
        loading={loading}
      />
      <BdmJobsModal
        isOpen={isBdmModalOpen}
        onClose={() => {
          setIsBdmModalOpen(false);
          setActiveEmployeeId(null);
          setSelectedNodeId(null);
          setPage(1)
          handleLimitChange(25)
        }}
        data={data}
        employeeId={activeEmployeeId}
        totalCount={countsData}
        page={page}
        limit={limit}
        setPage={setPage}
        handleLimitChange={handleLimitChange}
        loading={loading}
        onSubmissionClick={onSubmissionClick}
        submissionClickData={submissionClickData}
        subPage={subPage}
        subLimit={subLimit}
        subSetPage={subSetPage}
        subHandleLimitChange={subHandleLimitChange}
        type={type}
      />
      <InternalSubmissionModal
        isOpen={isInternalModalOpen}
        onClose={() => {
          setIsInternalModalOpen(false);
          setActiveEmployeeIdForStage(null);
          setActiveStageName(null);
          setSelectedNodeId(null);
          setPage(1)
          handleLimitChange(25)
        }}
        data={data}
        employeeId={activeEmployeeIdForStage}
        // duration={duration}
        stageName={activeStageName || "Internal Submission"}
        onStageNumberChange={onStageNumberChange}
        totalCount={countsData}
        page={page}
        limit={limit}
        setPage={setPage}
        handleLimitChange={handleLimitChange}
        tab2Data={tab2Data}
        tab3Data={tab3Data}
        tab2TotalCount={tab2TotalCount}
        tab3TotalCount={tab3TotalCount}
        loading={loading}
      />
      <StageModal
        isOpen={isStageModalOpen}
        onClose={() => {
          setIsStageModalOpen(false);
          setActiveEmployeeIdForStage(null);
          setActiveStageName(null);
          setSelectedNodeId(null);
          setPage(1)
          handleLimitChange(25)
        }}
        data={data}
        employeeId={activeEmployeeIdForStage}
        //duration={duration}
        stageName={activeStageName}
        onStageNumberChange={onStageNumberChange}
        totalCount={countsData}
        page={page}
        limit={limit}
        setPage={setPage}
        handleLimitChange={handleLimitChange}
        tab2Data={tab2Data}
        tab3Data={tab3Data}
        tab2TotalCount={tab2TotalCount}
        tab3TotalCount={tab3TotalCount}
        loading={loading}
      />
      <ExtraCountsModal
        isOpen={extraCountsModal}
        onClose={() => {
          setExtraCountsModal(false);
          setActiveEmployeeId(null);
          setSelectedNodeId(null);
          setPage(1)
          handleLimitChange(25)
        }}
        data={extraCountsData}
        employeeId={activeEmployeeId}
        totalCount={countsData}
        page={page}
        limit={limit}
        setPage={setPage}
        handleLimitChange={handleLimitChange}
        loading={loading}
        onSubmissionClick={onSubmissionClick}
        submissionClickData={submissionClickData}
        subPage={subPage}
        subLimit={subLimit}
        subSetPage={subSetPage}
        subHandleLimitChange={subHandleLimitChange}
        type={type}
        extraCounts={extraCounts}
        nodeParams={nodeParams}
      />
    </div>
  );
};

export default TreeHierarchy;
